var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ErrorPage"}},[_c('h2',[_vm._v("發生錯誤")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.msg)}}),_c('router-link',{attrs:{"to":"/"}},[_vm._v("回到首頁")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }